// import Vue from 'vue'
import { jsonp } from 'vue-jsonp'
import request from "./config/http.js";
import params from "./config/params.js";
import HTTP from "./config/listGIt.js";
const URL3 = "https://wxtest.cnknowledge.com/api";
const URL4 = "https://zwi.cnknowledge.com/api";
const URL5 = "https://zwiii.cnknowledge.com/api";

import global from "@/core/global/global.js"

import axios from "axios";
let getAuthorUrl = () => {
  let url = "";
  if (
    location.host.indexOf("cbtest.") != -1 ||
    location.host.indexOf(":80") != -1 ||
    location.host.indexOf("localhost") != -1
  ) {
    url = URL3; // 投审稿作者端测试环境
  } else if (location.host.indexOf("yucard") != -1) {
    url = URL5; // 投审稿作者端预生产环境
  } else {
    url = URL4; // 投审稿作者端正式环境
  }
  return url;
};

const BASE_URL = getAuthorUrl();
let dev = "/tsg-author";
let dev1 = "/txpy-web";

const apis = {
  // 埋点统计接口
  userBehaviorStatistics(data) {
    return HTTP.postFormData(global.global.tsgAdminUrl + "/point/editingCard", data);
  },

  getPerEditCardConfig(data) {
    return HTTP.get(global.global.tsgAdminUrl + "/api/getPerEditCardConfig", data);
  },

  getUserInfo(params) {
    //详情
    return HTTP.postJson(BASE_URL + "/zw-user/getUserDetail", params);
  },

  tokenGetUserInfo() {
    return HTTP.get(BASE_URL + "/zw-user/nf/getloginInfo", {}, false);
  },
  // titleList(data) {//职称列表
  // 	        return request({
  // 	            url: dev1 + "/zw/title/list",
  // 	            method: 'post',
  // 	            data: data,
  // 	            isToken: true,
  // 	        }).then((resault) => {
  // 	            return Promise.resolve(resault.data)
  // 	        })
  // 	    },
  //https://web.tonghangpingyi.com/txpy-web/zw/title/list
  // titleList(data) {
  // 	return HTTP.postFormData(BASE_URL + "/zw-user/scholar/nf/editModifyBaseInfo", data, false);
  // },
  editModifyBaseInfo(data) {
    return HTTP.postFormData(
      BASE_URL + "/zw-user/scholar/nf/editModifyBaseInfo",
      data,
      false
    );
  },
  getEduDictionary(data) {
    return HTTP.postFormData(
      BASE_URL + "/zw-public/code/getEduDictionary",
      data,
      false
    );
  },

  getPk() {
    return HTTP.get(BASE_URL + "/zw-user/getPk", false);
  },
  getUserIpConfig() {
    return new Promise((resolve, reject) => {
      jsonp(`https://apis.map.qq.com/ws/location/v1/ip?key=OWOBZ-6CZKQ-44B5T-2WQIO-YUTJ7-5TFJO`, {
        output: 'jsonp',
      }).then(resp => {
        resolve(resp)
      }).catch(err => {
        console.log(err);
      })
    })
  },
  regiteList(params) {
    return HTTP.get(BASE_URL + "/zw-public/sms/sendNew", params, false);
  },
  // 注册
  userList(params) {
    return HTTP.json(BASE_URL + "/zw-user/register/user", params, false);
  },
  //登录
  loginList(params) {
    return HTTP.json(BASE_URL + "/zw-user/bj/login", params, false);
  },
  //忘记密码
  foget(params) {
    return HTTP.posts(
      BASE_URL + "/zw-user/reset/nf/userRetrievePwd",
      params,
      false
    );
  },
  //退出登录http://47.93.50.49:5052/api/zw-user/bj/login
  logOut(params) {
    return HTTP.json(BASE_URL + "/zw-user/logout", params, false);
  },
  // export function logOut() {
  // 	return zwitCore.HTTP.json(BASE_URL + "/zw-user/logout");
  //   }
  /*
   采编接口
   名片夹
   pageNo
   pageSize
   userId
  */
  chatView(params) {
    return HTTP.get(
      BASE_URL + "/zw-chat/editing_center/cardHolder",
      params,
      false
    );
  },
  /*
  浏览记录
  /editing_center/cardBrowse
  pageNo
  pageSize
  userId
  */
  chatBrowse(params) {
    return HTTP.get(
      BASE_URL + "/zw-chat/editing_center/cardBrowse",
      params,
      false
    );
  },
  /*
  收藏名片
/editing_index/collection
  editId
  perId
  userId
  */
  collections(params) {
    return HTTP.json(
      BASE_URL + "/zw-chat/editing_index/collection",
      params,
      false
    );
  },
  /*采编详情
   */
  detailsLive(params) {
    return HTTP.get(BASE_URL + "/zw-chat/editing_index/detail", params, false);
  },
  /*我的作者列表
   */
  authorlist(params) {
    return HTTP.get(BASE_URL + "/zw-chat/myCard/authorList", params, false);
  },

  /*我的名片列表
   */
  acardslist(params) {
    return HTTP.get(BASE_URL + "/zw-chat/myCard/list", params, false);
  },

  /*统计列表
    /statistics/myPerformance
  */
  statist(params) {
    return HTTP.get(
      BASE_URL + "/zw-chat/statistics/myPerformance",
      params,
      false
    );
  },

  yejisutter(params) {
    return HTTP.get(
      BASE_URL + "/zw-chat/statistics/myContributer",
      params,
      false
    );
  },


  //采编回显
  detivesList(params) {
    return HTTP.get(BASE_URL + "/zw-chat/editing_card/detail", params, false);
  },
  //采编回显
  editListData(params) {
    return HTTP.get(BASE_URL + "/zw-chat/editing_card/editList2", params, false);
  },
  /*修改名片
      /editing_card/upd
   */
  updeat(params) {
    // return HTTP.json(BASE_URL + "/zw-chat/editing_card/upd", params, false);
    // 数据过长，不加密
    let param = JSON.stringify(params);
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: BASE_URL + "/zw-chat/editing_card/upd",
        baseURL: BASE_URL + "/zw-chat/editing_card/upd",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          rsa: "no",
        },
        data: param,
      })
        .then(
          (response) => {
            let result = response.data;
            console.log(result);
            // if (parseResult) {
            if (response.status === 200) {
              resolve(result);
            } else {
              reject(result);
            }
            // } else {
            //   resolve(result);
            // }
          },
          (err) => {
            reject(err);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  },
  /*修改作者昵称
        /myCard/updName
     */
  upName(params) {
    return HTTP.json(BASE_URL + "/zw-chat/myCard/updName", params, false);
  },
  /*查询推荐
    /myCard/del
   */
  chaxuTui(params) {
    return HTTP.json(
      BASE_URL + "/zw-information/adminInfo/getRecommend",
      params,
      false
    );
  },
  /*删除收藏
/editing_center/delHolder
*/
  shouDelet(params) {
    return HTTP.delete(
      BASE_URL + "/zw-chat/editing_center/delHolder",
      params,
      false
    );
  },
  /*删除浏览记录
/editing_center/delBrowse
 */
  liuDelet(params) {
    return HTTP.delete(
      BASE_URL + "/zw-chat/editing_center/delBrowse",
      params,
      false
    );
  },

  /*删除采编名片
/myCard/delMyCard
*/
  mycardDelet(params) {
    return HTTP.delete(BASE_URL + "/zw-chat/myCard/delMyCard", params, false);
  },

  /*推荐文献
/myCard/recommend
 */
  literature(params) {
    return HTTP.json(BASE_URL + "/zw-chat/myCard/recommend", params, false);
  },
  /*首页推荐文献分页
  /myCard/recommendPage
 */
  litesyPage(params) {
    return HTTP.get(
      BASE_URL + "/zw-chat/editing_index/recommendPage",
      params,
      false
    );
  },
  /*推荐文献分页
/myCard/recommendPage
/adminInfo/getRecommend
*/
  literaturePage(params) {
    return HTTP.get(BASE_URL + "/zw-chat/myCard/recommendPage", params, false);
  },

  /*恢复作者昵称*/
  recoveryName(params) {
    return HTTP.json(BASE_URL + "/zw-chat/myCard/recoveryName", params, false);
  },
  /*推荐文献置顶
    /myCard/top
   */
  literaTop(params) {
    return HTTP.put(BASE_URL + "/zw-chat/myCard/top", params, false);
  },
  /*删除推荐文献
     /myCard/del
    */

  literaDelet(params) {
    return HTTP.delete(BASE_URL + "/zw-chat/myCard/del", params, false);
  },
  /*消息列表
     /myCard/del
    */
  messaList(params) {
    return HTTP.get(BASE_URL + "/zw-chat/myCard/msgList", params, false);
  },

  /*消息列表
     /myCard/del
    */
  getNewsList(params) {
    return HTTP.get(BASE_URL + "/zw-chat/systemMsg/getNewsList", params, false);
  },
  /*回显用户中心http://47.93.50.49:5052/api/zw-user/scholar/baseInfo    //get
   */
  //http://47.93.50.49:5052/api/zw-user/scholar/modifyBaseInfo
  userup(params) {
    return HTTP.json(
      BASE_URL + "/zw-user/scholar/modifyBaseInfo",
      params,
      false
    );
  },
  async setUserInfo(data) {
    return await axios({
      url: `${BASE_URL}/zw-user/scholar/modifyBaseInfo`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
  },
  /*查看用戶詳情
  http://47.93.50.49:5052/api/zw-user/getUserDetail
  */
  userActives(params) {
    return HTTP.json(BASE_URL + "/zw-user/getUserDetail", params, false);
  },
  // userActives(params) {
  // 	return HTTP.get(BASE_URL + "/zw-user/scholar/baseInfo", params, false);
  // },

  //研究方向获取
  //http://127.0.0.1:8088/tsg-author/api/zw-public/title/getOneList?time=1637818647762
  direction(params) {
    // return HTTP.get(BASE_URL + "/zw-public/title/getOneList", params, false);
    return HTTP.get(BASE_URL + "/zw-public/title/getTitleList", params, false);
  },
  secondary(params) {
    return HTTP.get(BASE_URL + "/zw-public/title/getTwoList", params, false);
  },
  seThreeList(params) {
    return HTTP.get(BASE_URL + "/zw-public/title/getThreeList", params, false);
  },

  //http://47.93.50.49:5052/api/zw-public/researchField/getThreeList?prevSubjectId=48
  //http://47.93.50.49:5052/api/zw-public/researchField/getOneList
  //http://47.93.50.49:5052/api/zw-public/researchField/getTwoList?prevSubjectId=46
  direFlife(params) {
    return HTTP.get(
      BASE_URL + "/zw-public/researchField/getOneList",
      params,
      false
    );
  },
  seconFlife(params) {
    return HTTP.get(
      BASE_URL + "/zw-public/researchField/getTwoList",
      params,
      false
    );
  },
  seThrFlife(params) {
    return HTTP.get(
      BASE_URL + "/zw-public/researchField/getThreeList",
      params,
      false
    );
  },
  //得到全部研究方向
  getRelationList(params) {
    return HTTP.get(
      BASE_URL + "/zw-public/researchField/getRelationList",
      params,
      false
    );
  },
  /*
    聊天内容
    /chat/getChatPage
    groupId 聊天组id
    pageNo
    pageSize
    */
  getcentent(params) {
    return HTTP.get(BASE_URL + "/zw-chat/chat/getChatPage", params, false);
  },
  /*
  聊天组id
  reciveId  接受者id
  sendId   发送者id
  */
  getView(params) {
    return HTTP.get(BASE_URL + "/zw-chat/chat/getGroupId", params, false);
  },

  //稿件列表
  myArticleList(data) {
    return request({
      url: dev + "/web/myArticle/list",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //论文推荐
  reCommends(data) {
    return request({
      url: dev + "/web/paper/paperDownloadList",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  ssoSubject(data) {
    //学科列表
    return request({
      url: dev1 + "/subject/list",
      method: "get",
      params: {
        prevId: data || 0,
      },
      isToken: true,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  titleList(data) {
    //职称列表
    return request({
      url: dev1 + "/zw/title/list",
      method: "post",
      data: data,
      isToken: true,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //栏目设置
  columnSetup(data) {
    return request({
      url: dev + "/web/column/queryColumnList",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //公告列表
  /*
     pageNo  当前页码 从0开始
     pageSize    	每页显示个数
     periodicalId  期刊ID
  */
  Announ(data) {
    return request({
      url: dev + "/web/publication/queryPublicationList",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  // https://tsgauthor.cnknowledge.com/tsg-author/web/per/getPeriodicalByUserId?userId=108&time=1632794895615    切换期刊

  livtTop(data) {
    return request({
      url: dev + "/web/per/getPeriodicalByName",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  articleList(data) {
    return request({
      url: dev + "/web/complaint/saveComplaint",
      method: "post",
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  // https://tsgauthor.cnknowledge.com/tsg-author/web/paper/paperDetail?articleId=1333293759802249216
  //期刊详情
  qikan(data) {
    return request({
      url: dev + "/web/paper/paperDetail",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  /*期刊展示
     perId  期刊id
  */
  jourShow(data) {
    return request({
      url: dev + "/web/per/getNew",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  /*获取配置
     perId  期刊id
  */
  getRegister(data) {
    return request({
      url: dev + "/web/sso/getRegister",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  /*获取名片
     perId  期刊id
  */
  getCard(data) {
    return request({
      url: dev + "/web/per/callingCard",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  /*公告详情
  id-ID
  */
  details(data) {
    return request({
      url: dev + "/web/publication/queryPublication",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //进度条
  articleProgress(data) {
    return request({
      url: dev + "/web/myArticle/articleProgress",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  articleProgresss(data) {
    return request({
      url: dev + "/web/myArticle/articleProgresss",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  findProvinceList(data) {
    //省
    return request({
      url: dev + "/web/common/findProvinceList",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  findAreaList(data) {
    //市
    return request({
      url: dev + "/web/common/findAreaList",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  /*
  添加投诉/web/complaint/saveComplaint
  {
  "complainantId": 0,
  "complaintDetails": "string",
  "createTime": "2021-09-26T07:40:14.730Z",
  "id": 0,
  "linkman": "string",
  "objectOfComplaint": "string",
  "periodicalId": 0,
  "phone": "string",
  "status": 0
}
  */
  solives(data) {
    return request({
      url: dev + "/web/paper/paperDocumentPageList",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  thesisTemple(data) {
    return request({
      url: dev + "/web/per/thesisTemplet",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  accountIsExist(data) {
    return HTTP.posts(BASE_URL + "/zw-user/user/nf/account/isExist", data, false);
  },
  // 验证码生成
  captcha(params) {
    return HTTP.get(BASE_URL + '/zw-public/captcha/', params, false);
  },
  // 验证码验证
  captchaVerify(params) {
    return HTTP.json(BASE_URL + '/zw-public/captcha/verify', params, false);
  },
};
export default apis;
